var $=jQuery.noConflict();

$(document).ready(function(){
  $('.tt-slider-fullwidth').slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear',
    adaptiveHeight: true,
    autoplay: true,
  	autoplaySpeed: 4000,
  });
  
  /* product accordian */
  $('.product-accordian-block.active .product-content').slideDown();
  $('.product-accordian-block .accordian-title').on("click", function (e) {
    if($(this).parents('.product-accordian-block').hasClass('active')){
      $(this).parents('.product-accordian-block').removeClass("active");
      $(this).parent().find('.product-content').stop().slideUp();
    }else{
      $(this).parents('.product-accordian-block').addClass("active").siblings().removeClass("active");
      $(this).parent().find('.product-content').stop().slideDown();
      $(this).parent().siblings().find('.product-content').stop().slideUp();
    }
  });
  
  
  $('.product__video-wrapper').parents('.product__slide').addClass('product_video_block');
  
  // video section
  $('.video-play-btn').on('click', function () {
    var btn = $(this);
    var videoBlock = btn.parents('.video-block');
    var video = videoBlock.find('.html5').find('video')[0];
    var yt = videoBlock.find('.youtube').find('iframe')[0];
    var vimeo = videoBlock.find('.vimeo').find('iframe')[0];
    if (videoBlock.find('.video-inner').hasClass('html5')) {
      if (video.paused) {
        video.play();
        videoBlock.addClass('player-start').removeClass('player-pause');
      } else {
        video.pause();
        videoBlock.addClass('player-pause').removeClass('player-start');
      }
    }
    if (videoBlock.find('.video-inner').hasClass('youtube')) {
      yt.contentWindow.postMessage('{"event":"command","func":"' + "playVideo" + '","args":""}', "*");
      videoBlock.addClass('player-start').removeClass('player-pause');
    }
    if (videoBlock.find('.video-inner').hasClass('vimeo')) {
      $('.vimeo').each(function () {
        var othervimeo = $(this).find('iframe')[0];
        var vimeoPlayer1 = new Vimeo.Player(othervimeo);
        vimeoPlayer1.pause();
      });
      var vimeoPlayer = new Vimeo.Player(vimeo);
      vimeoPlayer.play();
      videoBlock.addClass('player-start').removeClass('player-pause');
    }
  });

  // SINGLE PRODUCT TEMPLATE

  if ($("body").hasClass("template-product")) {

    // Updates label text from Color to Choose a Color
    $(".variant__label").each(function() {
      var colorlabel = $(this).text();
      colorlabel = colorlabel.replace('Color', 'Choose a Color');
      $(this).text(colorlabel);
    });

    // Adjusts color of Color variants
    $("fieldset[name='Color'] .variant-input").each(function() {
      var optionColorName = $(this).attr("data-value");
      var optionColorHex = "#FFFFFF";
  
      switch (optionColorName) {
        case "Red":
          optionColorHex = "#ED0B0B";
          break;
        case "Blue":
          optionColorHex = "#081FEF";
          break;
        case "Turquoise":
          optionColorHex = "#2ED9F1";
          break;
        case "Purple":
          optionColorHex = "#5D00A5";
          break;
        case "Purple Triblend":
          optionColorHex = "#5D00A5";
          break;
        case "Black":
          optionColorHex = "#0E0E0E";
          break;
        case "Gold":
          optionColorHex = "#ef9b1c";
          break;
        case "Heather Grey":
          optionColorHex = "#9c9a96";
          break;
        case "Grey Triblend":
          optionColorHex = "#9c9a96";
          break;
        case "Carbon Grey":
          optionColorHex = "#b5b1ab";
          break;
        case "Athletic Heather":
          optionColorHex = "#9c9a96";
          break;
        case "Graphite":
          optionColorHex = "#504d46";
          break;
        case "Safety Orange":
          optionColorHex = "#ef6f1c";
          break;
        default:
          optionColorHex = "#F3F3F3";
      }
      
        $(this).find("label").css("background-color", optionColorHex);
        if (optionColorHex != "#F3F3F3") {
          $(this).find("label").css("font-size", "0px");
          $(this).find("label").css("padding", "20px");
        }
        else {
          $(this).find("label").css("padding-top", "12px");
          $(this).find("label").css("padding-bottom", "12px");
        }
  
    });

    // Quantity Selector JS
    $('.qtybox .btnqty').on('click', function(){
      var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
      if($(this).hasClass('qtyplus')) {
        qty++;
      }
      else {
        if(qty > 1) {
          qty--;
        }
      }
      qty = (isNaN(qty))?1:qty;
      $(this).parent('.qtybox').find('.quantity-input').val(qty);
    });
    
  }

  /* CURRENCY SELECTOR JS
  $("#localization_form").detach().appendTo("#currency-selector-header");*/

  /* HOME PAGE */
  if ($("body").hasClass("template-index")) {
    $("#CollectionSection-1556162914490 .section-header").append("<a href='https://www.heathersheroes.com/collections/all' class='btn homepage-yellow-btn js-no-transition' data-fancybox=''>Explore Products</a>");
    $("#shopify-section-1559687247066 .feature-row__text").append("<a href='https://www.heathersheroes.com/pages/our-story' class='btn homepage-yellow-btn js-no-transition' data-fancybox=''>Learn More</a>");

    // Updates label text from Color to Choose a Color
    $(".variant__label").each(function() {
      var colorlabel = $(this).text();
      colorlabel = colorlabel.replace('Color', 'Choose a Color');
      $(this).text(colorlabel);
    });

    // Adjusts color of Color variants
    $("fieldset[name='Color'] .variant-input").each(function() {
      var optionColorName = $(this).attr("data-value");
      var optionColorHex = "#FFFFFF";
  
      switch (optionColorName) {
        case "Red":
          optionColorHex = "#ED0B0B";
          break;
        case "Blue":
          optionColorHex = "#081FEF";
          break;
        case "Turquoise":
          optionColorHex = "#2ED9F1";
          break;
        case "Purple":
          optionColorHex = "#5D00A5";
          break;
        case "Purple Triblend":
          optionColorHex = "#5D00A5";
          break;
        case "Black":
          optionColorHex = "#0E0E0E";
          break;
        case "Gold":
          optionColorHex = "#ef9b1c";
          break;
        case "Heather Grey":
          optionColorHex = "#9c9a96";
          break;
        case "Grey Triblend":
          optionColorHex = "#9c9a96";
          break;
        case "Carbon Grey":
          optionColorHex = "#b5b1ab";
          break;
        case "Athletic Heather":
          optionColorHex = "#9c9a96";
          break;
        case "Graphite":
          optionColorHex = "#504d46";
          break;
        case "Safety Orange":
          optionColorHex = "#ef6f1c";
          break;
        default:
          optionColorHex = "#F3F3F3";
      }
      
        $(this).find("label").css("background-color", optionColorHex);
        if (optionColorHex != "#F3F3F3") {
          $(this).find("label").css("font-size", "0px");
          $(this).find("label").css("padding", "20px");
        }
        else {
          $(this).find("label").css("padding-top", "12px");
          $(this).find("label").css("padding-bottom", "12px");
        }
  
    });

    // Quantity Selector JS
    $('.qtybox .btnqty').on('click', function(){
      var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
      if($(this).hasClass('qtyplus')) {
        qty++;
      }
      else {
        if(qty > 1) {
          qty--;
        }
      }
      qty = (isNaN(qty))?1:qty;
      $(this).parent('.qtybox').find('.quantity-input').val(qty);
    });
  }

});


$(window).on('load', function () {

    var scene = document.getElementById('scene');
    var parallaxInstance = new Parallax(scene, {
      relativeInput: true
    });

  //PRODUCT TEMPLATE
  if ($("body").hasClass("template-product")) {
    //RBR Container Move
    $("#rbr-container-element-false").detach().appendTo("#product-second-section-right");
  }
  
});